import MarkdownIt from 'markdown-it'

const md = new MarkdownIt('zero', {
  breaks: true,
  linkify: true,
  typographer: true
}).enable([
  'list',
  'link',
  'autolink',
  'linkify',
  'newline',
  'replacements',
  'smartquotes',
  'escape'
])

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  tokens[idx].attrPush([ 'target', '_blank' ])

  return self.renderToken(tokens, idx, options, env, self)
}

export default md
